import { Component, computed, inject, input } from '@angular/core';
import { CONFIG } from '../../../../../libs/essentials/types/src/mea-config';
import Pharmacy from '../../../../../libs/essentials/types/src/pharmacy';
import { ShopProductUtil } from '../../../../../libs/essentials/util/src/shop-product.util';
import { WidgetButtonComponent } from './widget-button/widget-button.component';

@Component({
  selector: 'app-chat-and-shop-button',
  templateUrl: './chat-and-shop-button.component.html',
  styleUrls: ['./chat-and-shop-button.component.scss'],
  imports: [WidgetButtonComponent],
})
export class ChatAndShopButtonComponent {
  pharmacy = input.required<Pharmacy | null>();
  shopUrl = input<string>();

  private config = inject(CONFIG);
  protected readonly enduserBaseUrl = this.config.endUserBaseUrl;

  protected chatUrl = computed(() => {
    const pharmacy = this.pharmacy();
    if (!pharmacy) {
      return undefined;
    }
    const validShopAskQuestionUrl = ShopProductUtil.getShopAskQuestionUrl(pharmacy.onlineShop);
    const landingPageUrl = `${this.enduserBaseUrl}/${pharmacy.id}`;
    return validShopAskQuestionUrl ?? landingPageUrl;
  });
}
